import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Skeleton } from "antd";
import "./index.css";
import { Dropdown } from "../../common";
import MapHandler from "./MapHandler";
import data from "./data.json";
import Graphs from "./graphs/Graphs";
const Analysis = () => {
	let [listofDistricts, setDistricts] = useState([]);
	let [selectedDistrict, setSelectedDistrict] = useState("");

	useEffect(() => {
		(async () => {
			try {
				let { districts } = data;
				// let [districts] = await Promise.all([getDistricts()]);
				let listofDistricts = [];
				for (let dist of districts) {
					let { _id, district_name: region } = dist;
					listofDistricts.push({ _id, region });
				}
				setDistricts([...listofDistricts]);
			} catch (error) { }
		})();
	}, []);
	return (
		<Container fluid>
			<div className="mt-2">
				<Row className="">
					<div className="d-flex justify-content-between">
						<div className="d-flex align-items-center">Online Analytics Dashboard 2024</div>
						<div className="d-flex align-items-center p-1">
							<img
								src={'/MetrixLab_logo.png'}
								alt="Logo"
								height="32"
							/>
						</div>
						<div className="">
							<Dropdown
								list={listofDistricts}
								handler={(selected) => {
									setSelectedDistrict(selected);
								}}
								disable={false}
								Key="district_dropdown"
							/>
						</div>
					</div>
				</Row>
				<Row className="mt-1">
					<Col lg="6" sm="12">
						{selectedDistrict ? <Graphs selectedDistrict={selectedDistrict} /> : <Skeleton active />}
					</Col>
					<Col lg="6" sm="12">
						{selectedDistrict ? <MapHandler selectedDistrict={selectedDistrict} /> : <Skeleton active />}
					</Col>
				</Row>
			</div>
		</Container>
	);
};

export default Analysis;
